export default __webpack_public_path__ + "static/media/Group733.5e0cdf19.svg";